/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


/**************
 Upsell popups
 *************/

// close event
document.querySelectorAll(".upsell")?.forEach(function (element) {
    element.addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });
});

// open upsell event listener
document.querySelectorAll(".openUpsellInfo")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).showModal();
        document.querySelector("body").classList.add("noScroll");
    });
});

//close upsell event listener
document.querySelectorAll(".closeUpsell")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();
    });
});

document.querySelectorAll(".upsell")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})

// register dialog
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.upsell")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});

//preload image
function preloadImage(url) {
    let img = new Image();
    img.src = url;
}

// collection item swatch links
document.querySelectorAll('.collectionItemColorsSwatch')?.forEach(function (element) {
    element.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = this.dataset.url;
    });
});

